import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOutsideClick, sendTrackingInfo } from '@panel/commons';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import sortIcon from '@panel/commons/assets/icons/SortIcon.svg';
import Check from '@panel/commons/assets/icons/checkOrange.svg';
import CheckVA from '@panel/commons/assets/icons/checkBlueVamx.svg';
import CheckCM from '@panel/commons/assets/icons/checkBlueCM.svg';
import CheckUB from '@panel/commons/assets/icons/checkGreenUB.svg';
import Switch from '@panel/commons/lib/Switch';
import { FilterButton } from './styles';
import { FilterOperations, FilterSelectors } from '../../../../ducks/filter';
import { getTranslationByKey } from '../../../../helpers/datalayerTranslate';
import useUrlSearchParams from '../../hooks/useUrlSearchParams';

const Sort = () => {
  const { t } = useTranslation();
  const hasSortOnlineFirstCookie = Cookies.get('SortOnlineFirst');
  const sortOnlineFirstCookie = Cookies.get('SortOnlineFirst') && JSON.parse(Cookies.get('SortOnlineFirst'));
  const [dropDownState, setDropDownState] = useState(false);
  const [activeSortOnlineFirst, setActiveSortOnlineFirst] = useState(
    hasSortOnlineFirstCookie ? sortOnlineFirstCookie : true
  );
  const sortRef = useRef();
  const dispatch = useDispatch();
  const { appliedFilters } = useSelector(FilterSelectors.getFiltersState);
  const { setUrlSearch } = useUrlSearchParams();

  useOutsideClick(sortRef, () => {
    if (dropDownState) {
      setDropDownState(false);
    }
  });

  const sortCriteriaList = [
    'modifiedNewer',
    'modifiedOlder',
    'createdNewer',
    'createdOlder',
    'lowerPrice',
    'higherPrice',
    'lowerQuality',
    'higherQuality'
  ];

  const handleSortOnlineFirst = () => {
    setActiveSortOnlineFirst(!activeSortOnlineFirst);
    dispatch(FilterOperations.update({ onlineFirst: !activeSortOnlineFirst }));
    // se crea cookie para mantener los filtros aplicados al recargar el navegador.
    Cookies.set('SortOnlineFirst', !activeSortOnlineFirst, { expires: 999 });
    setDropDownState(false);
  };

  return (
    <FilterButton ref={sortRef} data-panel='postingsHeader_sortBtn' onClick={() => setDropDownState(!dropDownState)}>
      <img src={sortIcon} alt='Sort' />
      <p>{t('panel.bar.sortBy')}</p>
      <DropDownCheckList active={dropDownState}>
        {sortCriteriaList.map(criteria => (
          <DropdownOption
            data-panel={`postingsBar-sortMenu-option-${criteria}`}
            key={criteria}
            className={appliedFilters.sort.id && appliedFilters.sort.id === criteria && 'SEARCHBAR-DROP-SELECTED'}
            onClick={() => {
              sendTrackingInfo('Panel', 'Mis avisos', `Ordenamiento-${getTranslationByKey(criteria)}`);
              dispatch(FilterOperations.update({ sort: { id: criteria, displayName: criteria } }));
              setUrlSearch(criteria, 'sort');
            }}
          >
            {t(`panel.bar.select.sort.${criteria}`)}
          </DropdownOption>
        ))}
        <div className='separator' />
        <div className='sortOnlineFirst' data-panel='postingsBar-sortMenu-onlineFirst'>
          <span>{t(`panel.bar.select.sort.onlineFirst`)}</span>
          <Switch
            id='sortOnlineFisrt'
            toggled={activeSortOnlineFirst}
            onChange={() => handleSortOnlineFirst()}
            dataPanel='sortOnlineFisrt'
          />
        </div>
      </DropDownCheckList>
    </FilterButton>
  );
};

const siteId = process.env.REACT_APP_BUILD_SITE;

const DropDownCheckList = styled.div`
  display: ${({ active }) => (active ? 'flex' : 'none')};
  min-width: 238px;
  border-radius: 8px;
  border: 1px solid ${select('midLightGray')};
  background-color: ${select('white')};
  flex-direction: column;
  position: absolute;
  z-index: 900;
  top: 52px;
  right: 0px;
  padding: 10px 16px 16px;
  .separator {
    height: 0.5px;
    width: 100%;
    background-color: ${select('middleGray')};
    margin: 8px 0px;
  }
  .sortOnlineFirst {
    height: 32px;
    font-family: 'Hind';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 16px 0px 10px;
  }
`;

const DropdownOption = styled.div`
  font-family: 'Hind';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  :last-of-type {
    margin-bottom: 6px;
  }
  &.SEARCHBAR-DROP-SELECTED {
    &:after {
      margin-left: 8px;
      content: ${() => {
        if (siteId === 'CMBR') return `url(${CheckCM})`;
        if (siteId === 'UBPE') return `url(${CheckUB})`;
        if (siteId === 'VAMX') return `url(${CheckVA})`;
        return `url(${Check})`;
      }};
      width: 16px;
      height: 16px;
      vertical-align: sub;
    }
  }
`;

export default Sort;
